<template>
  <header>
    <div class="contract-msg">
      <div :style="clientWidth ? 'width:710px;height:400px;' : 'width:43%;height:400px;'" class="image-box">
        <!-- v-if="contractsDetails.houseInfoVo.houseInfoImgVo.interiorList" -->
        <img class="no-data" v-if="!detailsUrl" src="../../../../assets/images/nodataImg.svg" alt="" />
        <img
          :style="clientWidth ? 'width:710px;height:400px;' : 'width:100%;height:400px;'"
          v-else
          :src="OSS_BASE_URL + detailsUrl"
          alt=""
        />
      </div>
      <!-- <div v-else class="image-box">
          暂无图片
        </div> -->
      <div class="derails-box">
        <div class="more-box">
          <div>
            <h1>
              <span>合同编号：</span>
              {{ contractsDetails.contractCode
              }}<span style="padding-left: 30px; color: var(--ThemeColor)">{{
                contractsDetails.contractType === '2' ? '售' : '租'
              }}</span>
            </h1>
            <p class="price" v-if="contractsDetails.contractType === '1'">
              <span>签约租金：</span>{{ contractsDetails.rentExpense }}元/月
            </p>
            <p v-else>{{ contractsDetails.transactionAmount }}元</p>
          </div>
          <a-popover placement="bottomRight" v-model="moreVisible" trigger="click">
            <template slot="content">
              <!-- 普通经纪人编辑 -->
              <!-- 没有提交审核并且没有完成审核并且不是文件 是当前合同的签约人 -->
              <p
                @click="editContract"
                v-hasPermi="['system:contractsInfo:editAgent']"
                v-if="
                  contractsDetails.isSubmitAudit === 'N' &&
                    contractsDetails.signId === userId &&
                    contractsDetails.isDelivery == 'N' &&
                    contractsDetails.auditStatus != '3'
                "
              >
                编辑
              </p>
              <!--  -->
              <!-- 财务编辑 -->
              <!-- 提交审核后并且没有完成审核 可以编辑 -->
              <p
                @click="editContract"
                v-hasPermi="['system:contractsInfo:editFinancial']"
                v-if="
                  contractsDetails.isSubmitAudit === 'Y' &&
                    contractsDetails.auditStatus != '3'
                "
              >
                编辑
              </p>
              <!--  -->
              <a-popconfirm
                placement="rightBottom"
                ok-text="确定"
                cancel-text="取消"
                buttonWidth="100"
                @confirm="getDeleteContractsInfo"
              >
                <!-- <p
                  v-if="
                    contractsDetails.isArchive !== 'Y' &&
                    contractsDetails.isSubmitAudit !== 'Y' &&
                    contractsDetails.signId === userId
                  "
                  @click="editContract"
                  style="text-align: center"
                >
                  编辑
                </p>
                <a-popconfirm
                  v-if="contractsDetails.isSubmitAudit !== 'Y'"
                  v-hasPermi="['system:contractsInfo:remove']"
                  placement="rightBottom"
                  ok-text="确定"
                  cancel-text="取消"
                  buttonWidth="100"
                  @confirm="getDeleteContractsInfo"
                > -->
                <template slot="title">
                  <p>确定删除吗？</p>
                </template>
                <p
                  v-if="
                    contractsDetails.isSubmitAudit === 'N' &&
                      contractsDetails.signId === userId &&
                      contractsDetails.auditStatus != '3' &&
                      contractsDetails.isDelivery == 'N'
                  "
                  style="text-align: center"
                >
                  删除
                </p>
              </a-popconfirm>
              <!-- 签约人在提交审核前有编辑、删除合同权限；
                提交审核后（不管审核是否通过），都不能编辑、删除操作；
                审核通过后，财务分配业绩；
                业绩分配后，才能有归档操作。 -->
              <!-- <p
                  v-if="contractsDetails.auditStatus === '3' && contractsDetails.isArchive !== 'Y'"
                  v-hasPermi="['system:contractsInfo:archive']"
                  @click="getContractFile"
                  style="text-align: center"
                >
                  归档
                </p> -->
              <p
                v-if="contractsDetails.isSettlement === 'Y' && contractsDetails.isArchive !== 'Y'"
                v-hasPermi="['system:contractsInfo:archive']"
                @click="getContractFile"
                style="text-align: center"
              >
                归档
              </p>
              <!--  -->
              <!-- v-hasPermi="['system:contractsInfo:approval']" shenghe -->
              <p
                v-if="
                  contractsDetails.isSubmitAudit === 'N' &&
                    contractsDetails.isArchive !== 'Y' &&
                    contractsDetails.signId === userId &&
                    contractsDetails.auditStatus != '3' &&
                    contractsDetails.isDelivery == 'N' &&
                    contractsDetails.auditStatus != '3'
                "
                @click="getContractExamine"
                style="text-align: center"
              >
                审核
              </p>

              <p
                v-if="contractsDetails.auditStatus == '3' && contractsDetails.isDelivery == 'N'"
                @click="handInFile"
                style="text-align: center"
              >
                交件
              </p>
              <p
                @click="getMoney"
                v-if="contractsDetails.isDelivery == 'Y' && contractsDetails.isSettlement !== 'Y'"
                style="text-align: center"
              >
                结佣
              </p>

              <p v-if="contractsDetails.isArchive === 'Y'" @click="visible_modal = true" style="text-align: center">
                上传补充资料
              </p>
              <a-modal v-model="visible_modal" title="上传补充资料" @ok="handleOk">
                <h3>附件 (支持pdf、png、jpeg)</h3>
                <FileUpload type="image" :value="otherUrl" @input="uploadOtherUrl" @ossId="uploadOtherUrlOssId" />
              </a-modal>
            </template>
            <div class="more">
              <h1>...</h1>
              <p>更多</p>
            </div>
          </a-popover>
        </div>
        <div v-if="contractsDetails.contractType === '1'">
          <p>
            <span v-if="contractsDetails.paymentMethod">
              {{ '押' + getPay[0].replace('Y', '') + '元' + '付' + getPay[1] + '月' }}
            </span>
            &nbsp;&nbsp;|&nbsp;&nbsp;免租期{{ contractsDetails.rentfreePeriod }}天&nbsp;&nbsp;|&nbsp;&nbsp;转让费{{
              contractsDetails.transferFee
            }}万元&nbsp;&nbsp;|&nbsp;&nbsp;<span>递增：</span>{{ contractsDetails.growthPattern }}
          </p>
          <p>
            租期{{ $moment(contractsDetails.leaseStartTime).format('YYYY年MM月DD日') }}-{{
              $moment(contractsDetails.leaseEndTime).format('YYYY年MM月DD日')
            }}
          </p>

          <!-- <p class="remarks">
              {{ contractsDetails.contractsRemark ? contractsDetails.contractsRemark : '暂无备注' }}
            </p> -->
        </div>
        <div>
          <p v-if="contractsDetails && contractsDetails.lesseeRequirementSaleVo">
            {{ contractsDetails.paymentType | filterDict(paymentTypeList) }}&nbsp;&nbsp;|&nbsp;&nbsp;{{
              contractsDetails.lesseeRequirementSaleVo.investmentType | filterDict(investmentTypelist)
            }}
            &nbsp;&nbsp;|&nbsp;&nbsp;{{
              contractsDetails.lesseeRequirementSaleVo.customerType | filterDict(customerTypeList)
            }}
          </p>
          <p>{{ contractsDetails.signDate }}日签约</p>
          <a-row>
            <a-col :span="20">
              <div class="flex">
                <span>备注：</span>
                <p class="remarks" :class="{ 'no-remark-text': !contractsDetails.contractsRemark }">
                  {{ contractsDetails.contractsRemark ? contractsDetails.contractsRemark : '暂无备注' }}
                </p>
              </div>
            </a-col>
            <a-col :span="4">
              <p class="see-enclosure" v-if="contractsDetails.signId === userId" @click="checkFile()">查看附件</p>
              <p class="see-enclosure" v-else v-hasPermi="['system:contractsInfo:seefile']" @click="checkFile()">
                查看附件
              </p>
            </a-col>
          </a-row>
          <!-- <p class="remarks">
              {{ contractsDetails.contractsRemark ? contractsDetails.contractsRemark : '暂无备注' }}
            </p> -->

          <a-row class="user-box">
            <!-- <div class="user-box"> -->
            <template v-for="item in contractsDetails.contractLessorRelationVoList">
              <a-col
                :xxl="{ span: 12 }"
                :xl="{ span: 12 }"
                :lg="{ span: 15 }"
                :md="{ span: 15 }"
                v-if="item.lessorsType === '1'"
                :key="item.id"
              >
                <div class="user-msg">
                  <a-button class="tag-btn" type="primary" shape="circle">业主 </a-button>
                  <!-- <h1 style="margin-top: 20px">业主</h1> -->
                  <div>
                    <h1><span>名称：</span>{{ item.lessorsName }}</h1>
                    <p v-if="item.propertyAddress"><span>产权地址：</span>{{ item.propertyAddress }}</p>
                    <p><span>身份编码：</span>{{ item.lessorCardNo }}</p>
                    <p class="phone" v-if="item.lessorsPhone">
                      <span>电话：</span>{{ item.lessorsPhone.substr(0, 3) + '****' + item.lessorsPhone.substr(7, 11) }}
                    </p>
                    <p class="path" @click="toHourse">
                      <span>房源编号：</span>
                      <span>{{ contractsDetails.houseCode }}</span>
                    </p>
                  </div>
                  <!-- <div v-if="!islessorsType" style="padding-top: 40px">暂无信息</div> -->
                  <span
                    class="editBtn"
                    @click="editBtn(item, 'house')"
                    v-if="contractsDetails.auditStatus === '3'"
                    v-hasPermi="['system:contractsInfo:updateLessor']"
                  >
                    <a-button>编辑</a-button>
                  </span>
                </div>
              </a-col>
              <a-col
                :xxl="{ span: 12 }"
                :xl="{ span: 12 }"
                :lg="{ span: 15 }"
                :md="{ span: 15 }"
                v-if="item.lessorsType === '2'"
                :key="item.id"
              >
                <div class="user-msg">
                  <a-button class="tag-btn" type="primary" shape="circle">转让方 </a-button>
                  <!-- <h1 style="margin-top: 20px">转让方</h1> -->
                  <div>
                    <h1><span>名称：</span>{{ item.lessorsName }}</h1>
                    <p v-if="item.propertyAddress"><span>产权地址：</span>{{ item.propertyAddress }}</p>
                    <p><span>身份编码：</span>{{ item.lessorCardNo }}</p>
                    <p class="phone" v-if="item.lessorsPhone">
                      <span>电话：</span>{{ item.lessorsPhone.substr(0, 3) + '****' + item.lessorsPhone.substr(7, 11) }}
                    </p>
                    <p class="path" @click="toHourse">
                      <span>房源编号：</span>
                      <span>{{ contractsDetails.houseCode }}</span>
                    </p>
                  </div>
                  <!-- <div v-if="!islessorsType" style="padding-top: 40px">暂无信息</div> -->
                  <span
                    class="editBtn"
                    @click="editBtn(item, 'house')"
                    v-if="contractsDetails.auditStatus === '3'"
                    v-hasPermi="['system:contractsInfo:updateLessor']"
                  >
                    <a-button>编辑</a-button>
                  </span>
                </div>
              </a-col>
              <a-col
                :xxl="{ span: 12 }"
                :xl="{ span: 12 }"
                :lg="{ span: 15 }"
                :md="{ span: 15 }"
                v-if="item.lessorsType === '3'"
                :key="item.id"
              >
                <div class="user-msg">
                  <a-button class="tag-btn" type="primary" shape="circle">二房东 </a-button>
                  <!-- <h1 style="margin-top: 20px">二房东</h1> -->
                  <div>
                    <h1><span>名称：</span>{{ item.lessorsName }}</h1>
                    <p v-if="item.propertyAddress"><span>产权地址：</span>{{ item.propertyAddress }}</p>
                    <p><span>身份编码：</span>{{ item.lessorCardNo }}</p>
                    <p class="phone" v-if="item.lessorsPhone">
                      <span>电话：</span>
                      {{ item.lessorsPhone.substr(0, 3) + '****' + item.lessorsPhone.substr(7, 11) }}
                    </p>
                    <p class="path" @click="toHourse">
                      <span>房源编号：</span>
                      <span>{{ contractsDetails.houseCode }}</span>
                    </p>
                  </div>
                  <!-- <div v-if="!islessorsType" style="padding-top: 40px">暂无信息</div> -->

                  <span
                    class="editBtn"
                    @click="editBtn(item, 'house')"
                    v-if="contractsDetails.auditStatus === '3'"
                    v-hasPermi="['system:contractsInfo:updateLessor']"
                  >
                    <a-button>编辑</a-button>
                  </span>
                </div>
              </a-col>
            </template>
            <a-col :xxl="{ span: 12 }" :xl="{ span: 12 }" :lg="{ span: 15 }" :md="{ span: 15 }">
              <div class="user-msg">
                <!-- <h1 class="tenant">租客</h1> -->
                <a-button class="tag-btn" type="primary" shape="circle">
                  {{ contractsDetails.contractType === '2' ? '售客' : '租客' }}
                </a-button>
                <div>
                  <h1>
                    <span>名称：</span>
                    <span>{{ contractsDetails.lesseeName }}</span>
                    <span
                      v-if="contractsDetails.lesseeBrandName"
                    ><span>品牌：</span><span>{{ contractsDetails.lesseeBrandName }}</span></span
                    >
                  </h1>
                  <p><span>身份编码：</span>{{ contractsDetails.lesseeCardNo }}</p>
                  <p class="phone" v-if="contractsDetails.lesseePhone">
                    <span>电话：</span
                    >{{
                      contractsDetails.lesseePhone.substr(0, 3) + '****' + contractsDetails.lesseePhone.substr(7, 11)
                    }}
                  </p>
                  <p class="path" @click="toTourist">
                    <span>客源编号：</span>
                    <span v-if="contractsDetails.lesseeRequirementVo">{{
                      contractsDetails.lesseeRequirementVo &&
                        contractsDetails.lesseeRequirementVo.lesseeInfoVo &&
                        contractsDetails.lesseeRequirementVo.lesseeInfoVo.lesseeCode
                    }}</span>
                    <span v-if="contractsDetails.lesseeRequirementSaleVo">{{
                      contractsDetails.lesseeRequirementSaleVo &&
                        contractsDetails.lesseeRequirementSaleVo.lesseeInfoVo &&
                        contractsDetails.lesseeRequirementSaleVo.lesseeInfoVo.lesseeCode
                    }}</span>
                  </p>
                </div>
                <span
                  class="editBtn"
                  @click="editBtn(contractsDetails, 'tourist')"
                  v-if="true || contractsDetails.auditStatus === '3'"
                  v-hasPermi="['system:contractsInfo:updateLessee']"
                >
                  <a-button>编辑</a-button>
                </span>
              </div>
            </a-col>
            <!-- </div> -->
          </a-row>
        </div>

        <!-- <p class="see-enclosure" v-if="contractsDetails.signId === userId" @click="enclosureVisible = true">
            查看附件
          </p>
          <p
            class="see-enclosure"
            v-else
            v-hasPermi="['system:contractsInfo:seefile']"
            @click="enclosureVisible = true"
          >
            查看附件
          </p> -->
        <!-- -if="contractsDetails.signId!==userId" -->
        <!-- <p class="see-enclosure" v-if="contractsDetails.signId === userId" @click="enclosureVisible = true">
            查看附件
          </p>
          <p
            class="see-enclosure"
            v-else
            v-hasPermi="['system:contractsInfo:seefile']"
            @click="enclosureVisible = true"
          >
            查看附件
          </p> -->
      </div>
    </div>
    <ModalForm
      title="交件"
      ref="handInModalRef"
      :formList="formSchemas"
      :formData="handInForm"
      @handleOk="submitModal"
    />
    <ModalForm
      title="结佣"
      ref="getMoneyModalRef"
      :formList="formSchemas"
      :formData="getMoneyForm"
      @handleOk="submitModal"
    />
  </header>
</template>

<script>
import FileUpload from '@/components/FileUpload/index.vue'
import ModalForm from '@/components/modal/modalForm.vue'
import moment from 'moment'
const loadingStatus = false
export default {
  components: {
    FileUpload,
    ModalForm
  },
  props: {
    userId: {
      type: [Number, String],
      default: ''
    },
    clientWidth: {
      type: [null, Number, String],
      default: null
    },
    islessorsType: {
      type: Boolean,
      default: false
    },
    detailsUrl: {
      type: String,
      default: ''
    },
    contractsDetails: {
      type: Object,
      default: () => ({})
    },
    paymentTypeList: {
      type: Array,
      default: () => []
    },
    investmentTypelist: {
      type: Array,
      default: () => []
    },
    customerTypeList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    contractsDetails: {
      handler () {},
      deep: true,
      immediate: true
    }
  },
  data () {
    const OSS_BASE_URL = process.env.VUE_APP_OSS_URL
    return {
      OSS_BASE_URL,
      moreVisible: false,
      visible_modal: false,
      otherUrl: '',
      otherUrlOssid: '',
      formSchemas: [
        {
          filed: 'time',
          label: '选择时间',
          component: 'DatePicker',
          showTime: true,
          placeholder: '选择时间',
          valueFormat: 'YYYY-MM-DD HH:mm:ss',
          format: 'YYYY-MM-DD HH:mm:ss'
        }
      ],
      handInForm: {
        time: moment(new Date())
      },
      getMoneyForm: {
        time: moment(new Date())
      }
    }
  },
  computed: {
    getPay () {
      const arr = this.contractsDetails.paymentMethod.split('F')
      return arr
    }
  },
  methods: {
    editContract () {
      this.$emit('editContract')
    },
    getDeleteContractsInfo () {
      this.$emit('getDeleteContractsInfo')
    },
    getContractFile () {
      this.$emit('getContractFile')
    },
    getContractExamine () {
      this.$emit('getContractExamine')
    },
    handleOk () {
      this.$emit('handleOk', { otherUrl: this.otherUrlOssid })
    },
    checkFile () {
      this.$emit('checkFile')
    },
    editBtn (obj, thatOne) {
      this.$emit('editBtn', obj, thatOne)
    },
    uploadOtherUrl (url) {
      this.otherUrl = url
    },
    uploadOtherUrlOssId (id) {
      this.otherUrlOssid = id
    },
    closeFileModal () {
      this.visible_modal = false
      this.otherUrl = ''
    },
    // 交件
    handInFile () {
      this.handInForm = {
        time: moment(new Date())
      }
      this.$refs.handInModalRef.openModal()
      this.updateType = 1
      // this.$emit('handInFile')
    },
    // 结佣
    getMoney () {
      this.getMoneyForm = {
        time: moment(new Date())
      }
      // console.log(this.contractsDetails, 'contedee')
      if (this.contractsDetails.receivableAmount === this.contractsDetails.realityAmount) {
        this.$refs.getMoneyModalRef.openModal()
        this.updateType = 2
      } else {
        this.$message.warning('应收金额等于实收金额才能结佣')
      }
    },
    submitModal (val) {
      // console.log(val,'0000')
      val.updateType = this.updateType
      this.$emit('submitPutStatus', val)
    },
    // 关闭弹窗
    closeModal () {
      this.$refs.handInModalRef.closeModal()
      this.$refs.getMoneyModalRef.closeModal()
    },
    // 跳转
    toHourse () {
      const path = this.contractsDetails.contractType === '2' ? '/houses/detail/sell' : '/houses/detail/index'
      this.$router.push({
        path,
        query: {
          id: this.contractsDetails.houseId,
          formTitle: this.contractsDetails.contractType === '2' ? '售房详情' : '租房详情'
        }
      })
    },
    toTourist () {
      const path = this.contractsDetails.contractType === '2' ? '/tourist/sellDetails' : '/tourist/details'
      this.$router.push({
        path,
        query: {
          id: this.contractsDetails.lesseeRequirementId
          // formTitle: this.contractsDetails.contractType === '2' ? '售房详情' : '租房详情',
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
header {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid rgb(243, 240, 240);
  padding-bottom: 20px;
  width: 100%;
  margin-bottom: 20px;
  .contract-msg {
    display: flex;
    width: 100%;
    .image-box {
      // width: 710px;
      width: 44%;
      line-height: 400px;
      text-align: center;
      align-self: center;
      img {
        // width: 710px;
        height: 400px;
        // width: 40%;
        object-fit: cover;
        border-radius: 15px;
        // height: 400px;
      }
      .no-data {
        // width:350px;
        width: 40%;
        height: 150px;
        text-align: center;
      }
    }
    .derails-box {
      padding-left: 26px;
      display: flex;
      flex: 1;
      flex-direction: column;
      //
      .more-box {
        display: flex;
        justify-content: space-between;
        .more {
          text-align: center;
          margin-right: 30px;
          cursor: pointer;
          h1 {
            background-color: var(--ThemeColor);
            color: #fff;
            line-height: 30px;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            text-align: center;
          }
          p {
            color: var(--ThemeColor);
            font-size: 12px;
          }
        }
      }
      h1 {
        font-size: 14px;
        color: #222222;
        font-weight: 700;
      }
      p {
        font-size: 14px;
        font-weight: 600;
        color: var(--ThemeColor);
        letter-spacing: 1px;
      }
      .price {
        font-size: 14px;
        font-weight: 500;
      }
      .remarks {
        color: #888888;
        font-size: 12px;
        font-weight: 400;
        max-height: 220px;
        overflow: auto;
        margin-bottom: 20px;
      }
      .no-remark-text {
        height: auto !important;
      }
      .see-enclosure {
        font-size: 12px;
        color: var(--ThemeColor);
      }
    }
  }
}
.user-box {
  width: 100%;
  // display: flex;
  // justify-content: space-between;
  // margin: 60px 0;
  // border-top: 1px solid rgb(243, 240, 240);
  // border-bottom: 1px solid rgb(243, 240, 240);
  // padding: 60px 0;
  .user-msg {
    width: 99%;
    height: 165px;
    border: 1px solid rgb(243, 240, 240);
    border-radius: 15px;
    padding: 20px 0px 10px 10px;
    display: flex;
    margin-bottom: 5px;
    font-size: 12px !important;
    > h1 {
      width: 80px;
      height: 80px;
      background-color: var(--ThemeColor);
      border-radius: 50%;
      line-height: 80px;
      text-align: center;
      font-size: 12px;
      color: #fff;
      font-weight: 700;
    }
    .tenant {
      background-color: #7dd9a5;
    }
    > div {
      padding-left: 20px;
      h1 {
        font-size: 12px;
        font-weight: 700;
      }
      p {
        font-size: 12px;
        font-weight: 600;
      }
      .phone {
        font-size: 12px;
      }
      span {
        display: inline-block;
      }
      // span:nth-child(1) {
      // margin-right: 10px;
      // }
      // span:nth-child(2) {
      // margin-left: 10px;
      // }
    }
    .editBtn {
      flex: 1;
      text-align: right;
      line-height: 100px;
      margin-right: 20px;
    }
    .editBtn {
      flex: 1;
      text-align: right;
      line-height: 100px;
      margin-right: 20px;
    }
  }
}

#components-popover-demo-placement .ant-btn {
  width: 200px;
  text-align: center;
  padding: 0;
  margin-right: 8px;
  margin-bottom: 2px;
}

.ant-popover {
  p {
    border-bottom: 4px solid #f2f6fc;
    padding: 8px 80px;
    margin: 0;
    cursor: pointer;
  }
  p:hover {
    color: var(--ThemeColor);
  }
}

.flex {
  display: flex;
  font-size: 12px;
}

.tag-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px !important;
}
.path {
  cursor: pointer;
}
</style>
